import { queryOptions, useQuery } from '@tanstack/react-query';

import API from '@api';

/** Сторисы меняются редко — кэшируем на 10 минут */
const STORIES_STALE_TIME = 10 * 60 * 1000;
const STORIES_GC_TIME = 15 * 60 * 1000;

export const storiesQueryOptions = () =>
  queryOptions({
    queryKey: ['stories'],
    queryFn: () => API.getStories(),
    staleTime: STORIES_STALE_TIME,
    gcTime: STORIES_GC_TIME
  });

export const useStoriesQuery = () => useQuery(storiesQueryOptions());

/** Сторисы конкретной акции (страница /promotion/:id) */
export const storiesByPromotionIdQueryOptions = (
  promotionId?: number | null
) =>
  queryOptions({
    queryKey: ['storiesByPromotionId', promotionId ?? null],
    queryFn: () =>
      API.getStoriesByPromotionId({
        promotionId: Number(promotionId),
        imageSizeStory: 'h600',
        imageSizeSlide: 'h600'
      }),
    select: res => res.getStoriesByPromotionId ?? undefined,
    enabled: !!promotionId,
    staleTime: STORIES_STALE_TIME,
    gcTime: STORIES_GC_TIME
  });
